import React, { useState, useEffect, CSSProperties, useRef } from "react";
import { FaPlus, FaSearch } from "react-icons/fa";
import { MdToggleOn, MdEdit, MdDeleteOutline } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "../../../utils/redux/hooks";
import {
  addFaq,
  addServices,
  getAllCategories,
  getServices,
} from "../../../utils/apis/func";
import {
  addcategories,
  addchats,
  addisLoading,
  addservices,
} from "../../../utils/redux/mainSlice";
import { RootState } from "../../../utils/redux/store";
import Scrollbar from "../../scrollbar";
import { toast } from "react-toastify";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import { Select } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import ImageUploading from "react-images-uploading";
import axios from "axios";
import ClipLoader from "react-spinners";
import { Dots, Spinner } from "react-activity";
import "react-activity/dist/library.css";
import EditComp from "./component/EditComp";
import DeleteContent from "./component/DeleteComp";
import { exportToCsv } from "../walletTabs/TempTwoTabs/allOrders";

const Services = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const services = useAppSelector((store: RootState) => store.user.services);

  console.log("SRVICES -------++++++", services);
  const tableRef = useRef<any>(null);

  // const handlePrint = useReactToPrint({
  //   content: () => tableRef.current,
  // });
  const [searchTerm, setSearchTerm] = useState("");
  const filteredServices = services.filter((item) =>
    item.name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );
  useEffect(() => { setCurrentPage(1); }, [searchTerm]);

  const itemsPerPage = 15;
  const totalItems = filteredServices.length;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const itemsToShow = filteredServices.slice(startIndex, endIndex);

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchServices = async () => {
      const res: any = await getServices("");
      console.log(res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addservices(res?.data?.services));
      }
    };
    fetchServices();
  }, [dispatch]);

  function formatDate(inputDate: string) {
    const date = new Date(inputDate);

    // Get day, month, year, hours, and minutes
    const day = date.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Assemble the formatted date
    const formattedDate = `${day} ${month} ${year}, ${hours}:${minutes}`;

    return formattedDate;
  }

  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);

  const handleOpen = () => setOpen(!open);
  const handleOpenEdit = () => setOpenEdit(!openEdit);
  const handleDelete = () => setOpenDelete(!openDelete);
  const [faqData, setfaqData] = useState({
    name: "",
    value: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setfaqData({
      ...faqData,
      [name]: value,
    });
  };
  const [selectedCategory, setSelectedCategory] = useState("");
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [images, setImages] = React.useState([]);
  const [selectImage, setselectImage]: any = useState();
  const [Uploadimages, setUploadImages] = React.useState(null);
  const categories = useAppSelector(
    (store: RootState) => store.user.categories
  );
  const [EditItem, setEditItem]: any = useState(null);
  const handleSendNotif = async () => {
    if (!faqData.name.trim() || !selectedCategory) {
      toast.error("Enter a service name and choose a category.");
      return;
    }
    if (!Uploadimages) {
      toast("Service Image is Required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    // e.preventDefault();
    console.log(faqData);

    setisLoading(true);
    const catId = categories?.filter((item) => item.name === selectedCategory);

    const res: any = await addServices({
      name: faqData.name.trim(),
      value: faqData.name.trim(),
      categoryId: catId?.[0]?.id || catId?.[0]?._id,
      imageURL: Uploadimages,
    });
    console.log("Add Services", res);

    if (res?.status === 200 || res?.status === 201) {
      toast("Services Added Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setOpen(false);
      const latest: any = await getServices("");
      if (latest?.status === 200) dispatch(addservices(latest.data.services));
    } else {
      toast.error("Failed to add service. Please try again.");
    }
    dispatch(addisLoading(false));
    setisLoading(false);
  };
  const handleCategoryChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setSelectedCategory(event.target.value);
    console.log(event.target.value);
  };
  useEffect(() => {
    const fetchChats = async () => {
      dispatch(addisLoading(true));
      const res: any = await getAllCategories("");
      console.log("res get all categories ", res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addcategories(res?.data?.data));
      }
      dispatch(addisLoading(false));
    };
    fetchChats();
  }, []);
  const maxNumber = 1;
  const onChange = (imageList: any, addUpdateIndex: any) => {
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  const handleFileChange = async (event: any) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      // Do something with the selected file
      console.log("Selected File:", selectedFile);
      setselectImage(selectedFile);
      const uploadRes = await uploadFile(selectedFile);
      setUploadImages(uploadRes?.url);
      console.log("UPLOADRESS", uploadRes);
    }
  };
  const uploadFile = async (image: string | Blob) => {
    setisLoading(true);
    dispatch(addisLoading(true));
    const formData = new FormData();
    formData.append(" ", image);
    formData.append("folder", "services");
    try {
      const response = await axios.post(
        "https://api.pureworker.com/api/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("File uploaded successfully", response.data);
      return response?.data;
    } catch (error) {
      console.error("Error uploading file", error);
    } finally {
      dispatch(addisLoading(false));
      setisLoading(false);
    }
  };
  const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
  };

  const headers = ["Date", "Category", "Order Count"];
  const keys = ["createdAt", "name", "numberOfOrders"];

  const handleExportToCSV = () => {
    console.log(services);
    exportToCsv({
      data: services,
      headers,
      keys,
      fileName: "pureworkerServices.csv",
    });
  };
  return (
    <div className="px-0 lg:px-3">
      <div className="flex justify-between my-2 px-6">
        <p className="text-[#88087B] font-roboto text-3xl font-medium leading-normal">
          Services
        </p>
        {/* <FaPlus
          size={25}
          className="text-[#fff] bg-[#88087B] p-1  rounded-md"
        /> */}
        <button
          aria-label="Add service"
          data-modal-target="authentication-modal"
          data-modal-toggle="authentication-modal"
          className="block text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
          onClick={handleOpen}
        >
          <FaPlus
            size={25}
            className="text-[#fff] bg-[#88087B] p-1 rounded-md"
          />
        </button>
      </div>
      <div className="mb-4">
        <div className="ml-10 flex items-center sm:flex ">
          <FaSearch className="text-[#88087B]" />
          <input
            type="text"
            className=" rounded-full ml-4 px-4 py-2 sm:w-48 lg:w-70 font-roboto text-sm font-normal leading-5 tracking-tighter text-[#8E8E93] focus:outline-none"
            placeholder="Search Services"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <section className="px-3">
        <div className="relative overflow-x-auto px-3 rounded-t-lg">
          <table className="w-full " ref={tableRef}>
            <thead className="bg-[#88087B] text-[#F7F7F7] font-roboto text-sm lg:text-lg font-medium whitespace-nowrap">
              <tr>
                <th className="py-3 px-10">Date</th>
                <th className="py-3 px-5">Service</th>
                <th className="py-3 px-10">Total Orders</th>
                {/* <th className="py-3 px-10">Status</th> */}
                <th className="py-3 px-10">Action</th>
                <th className="py-3 px-10"></th>
              </tr>
            </thead>
            <tbody>
              {itemsToShow.map(
                (item) => (
                  <tr
                    key={item._id || item.id}
                    className="hover:bg-[#87878d] whitespace-nowrap transition duration-300 font-roboto text-xs font-medium leading-normal border border-b-[#525050]"
                  >
                    {/* <td className="py-4 px-16 text-center">
                    <div>{item.dateTime.date}</div>
                    <div>{item.dateTime.time}</div>
                  </td>
                  <td className="py-4 px-16">{item.category}</td>
                  <td className="py-4 px-16">{item.totalOrders}</td> */}
                    <td className="py-4 px-16 text-center">
                      {formatDate(item?.createdAt)}
                    </td>
                    <td className="py-4 px-4 flex flex-row items-center">
                      {item?.imageURL && (
                        <img
                          src={item?.imageURL}
                          alt=""
                          width="100"
                          className="sm:w-10 sm:h-10 mr-2"
                        />
                      )}
                      {item?.name}
                      {item.disabled && (
                        <span color="red" className="text-red-900">
                          {" "}
                          (DISABLED)
                        </span>
                      )}
                    </td>
                    <td className="py-4 px-16">{item?.numberOfOrders || 0}</td>
                    {/* <td className="py-4 px-16">
                      <MdToggleOn
                        size={24}
                        className="text-[#1A6C13] bg-[#fff]  border border-[fff] rounded-lg"
                      />
                    </td> */}
                    <td
                      onClick={() => {
                        handleOpenEdit();
                        setEditItem(item);
                      }}
                      className="py-4 px-6"
                    >
                      <MdEdit size={24} />
                    </td>
                    <td
                      onClick={() => {
                        // handleOpenEdit();
                        handleDelete();
                        setEditItem(item);
                      }}
                      className="py-4 px-8"
                    >
                      <MdDeleteOutline
                        size={25}
                        className=" cursor-pointer text-[#fff] bg-[#D11C1C] rounded-md p-0.5"
                      />
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
        <div className="  flex justify-end px-4 mt-8 -mb-8 ">
          <button
            onClick={handleExportToCSV}
            className="bg-[#88087B] border border-[#88087B] px-2 rounded-md text-[#FFCD1E] text-center text-shadow font-roboto text-base font-medium leading-normal"
          >
            Export
          </button>
        </div>
        <Scrollbar
          currentPage={currentPage}
          totalPages={Math.ceil(totalItems / itemsPerPage)}
          itemsPerPage={itemsPerPage}
          totalItems={totalItems}
          onPrevPageClick={handlePrevPageClick}
          onNextPageClick={handleNextPageClick}
        />
      </section>

      <Dialog open={open} handler={handleOpen}>
        <DialogHeader>Add Services</DialogHeader>
        <DialogBody>
          <section className="flex flex-col lg:flex-row w-full  gap-16 px-3 lg:px-6 ">
            <div className="flex flex-col gap-7 w-full  font-roboto text-sm font-normal leading-normal">
              <div className="mb-0">
                <label
                  htmlFor="qst"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="qst"
                  name="name"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter Service Name"
                  required
                  onChange={handleChange}
                />
              </div>

              <Select
                name="_category"
                value={selectedCategory}
                onChange={handleCategoryChange}
              >
                <option value="" disabled hidden>
                  Select service category
                </option>
                {categories?.map((item) => {
                  return <option key={item._id || item.id} value={`${item.name}`}>{item?.name}</option>;
                })}
              </Select>
              <div className="mb-0">
                <label
                  htmlFor="qst"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Add Service Image
                </label>
                <input
                  type="file"
                  id="img"
                  name="img"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </div>
              {Uploadimages !== null && (
                <div>
                  <img src={Uploadimages} alt="" width="100" />
                </div>
              )}

              {/* <ImageUploading
                multiple
                value={images}
                onChange={onChange}
                maxNumber={maxNumber}
                dataURLKey="data_url"
              >
                {({
                  imageList,
                  onImageUpload,
                  onImageRemoveAll,
                  onImageUpdate,
                  onImageRemove,
                  isDragging,
                  dragProps,
                }: any) => (
                  // write your building UI
                  <div className="upload__image-wrapper">
                    <button
                      className=" px-4 py-1 rounded bg-[#88087B] mr-4 text-white"
                      style={isDragging ? { color: "red" } : undefined}
                      onClick={onImageUpload}
                      {...dragProps}
                    >
                      Click or Drop here
                    </button>
                    &nbsp;
                    {imageList?.length > 0 && (
                      <button
                        className=" px-4 py-1 rounded bg-[#88087B] mr-4 text-white"
                        onClick={onImageRemoveAll}
                      >
                        Remove all images
                      </button>
                    )}
                    {imageList.map((image: any, index: any) => (
                      <div key={index} className="image-item">
                        <img src={image["data_url"]} alt="" width="100" />
                        <div className="image-item__btn-wrapper  mt-3">
                          <button
                            className=" px-4 py-1 rounded bg-[#88087B] mr-4 text-white"
                            onClick={() => onImageUpdate(index)}
                          >
                            Update
                          </button>
                          <button
                            className=" px-4 py-1 rounded bg-[#88087B] mr-4 text-white"
                            onClick={() => onImageRemove(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </ImageUploading> */}
              <div className="px-12 w-full flex justify-center items-center lg:block">
                {isLoading ? (
                  <>
                    <Dots size={40} color="var(--admin-accent)" />
                    {/* <Spinner color="admin.accent" size={20}/> */}
                  </>
                ) : (
                  <button
                    // disabled={isLoading}
                    onClick={(e) => {
                      handleSendNotif();
                      //   const catId = categories?.filter((item)=>
                      //   item.name === selectedCategory
                      // )
                      // console.log(Uploadimages, catId, catId?.[0]?.id);
                    }}
                    className="bg-[#88087B] text-[#FFCD1E] text-center text-shadow font-roboto text-lg font-medium leading-normal sm:w-3/4 lg:w-[40%] lg:mx-auto py-2 rounded-md mt-4 "
                  >
                    Add Services
                  </button>
                )}
              </div>
            </div>
          </section>
        </DialogBody>
      </Dialog>

      {/* Edit Modal */}
      {/* {openEdit && <EditComp categories={categories} EditItem={EditItem} />} */}
      <Dialog open={openEdit} handler={handleOpenEdit}>
        {openEdit && EditItem && <EditComp
          key={EditItem._id || EditItem.id}
          categories={categories}
          EditItem={EditItem}
          close={() => {
            setOpenEdit(false);
          }}
        />}
      </Dialog>

      <Dialog open={openDelete} handler={handleDelete}>
        {openDelete && EditItem && <DeleteContent
          key={EditItem._id || EditItem.id}
          close={() => setOpenDelete(false)}
          item={EditItem}
        />}
      </Dialog>
    </div>
  );
};

export default Services;
